import {Component, Input} from '@angular/core';

@Component({
  selector: 'admin-buttons',
  template: `
    <div class="row" style="font-size:1.3em;padding-top:50px;">
      <div class="col-md-4">
        <a routerLink="users" class="col-md-4">
          <i class="fa fa-user fa-2x"></i>&nbsp;Users
        </a>
      </div>
      <div *ngIf="isSuperUser" class="col-md-4">
        <a routerLink="lists">
          <i class="fa fa-list-alt fa-2x"></i> Lists
        </a>
      </div>
    </div>
  `
})
export class AdminButtonsComponent {
  @Input() isSuperUser: boolean;
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/admin-buttons.ts